import { Path } from '@/main/router/routerPath';

import Edit from './Edit.vue';
import { CRUMB_LABEL_KEY, NAME } from './constants';

export const router = new Path(NAME, { Edit }, CRUMB_LABEL_KEY);
